   
import { call, all } from 'redux-saga/effects';
import rootLayoutSaga from '../Areas/Layout/sagas';
import rootPlanTemplateSaga from '../Areas/PlanTemplate/sagas';
import rootLoginSaga from '../Areas/Login/sagas';
import rootPlanHandleSaga from '../Areas/PlanHandle/sagas';
import rootMenuAuthorizationSaga from '../Areas/MenuAuthorization/sagas';
import rootMenuRoleSaga from '../Areas/MenuRole/sagas';
import rootUserMenuSaga from '../Areas/MenuUser/sagas';
import rootDashboardSaga from '../Areas/Dashboard/sagas';
import rootConfirmPageSaga from '../Areas/HomeConfirm/sagas';
//IndexImportHygen

export default function* rootSaga() {
  yield all([
    call(rootLayoutSaga),
    call(rootPlanTemplateSaga),
    call(rootLoginSaga),
    call(rootPlanHandleSaga),
    call(rootMenuAuthorizationSaga),
    call(rootMenuRoleSaga),
    call(rootUserMenuSaga),
    call(rootDashboardSaga),
    call(rootConfirmPageSaga),
    //IndexUsingHygen
])
}